// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import ElementUI from 'element-ui'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import { Button, Cell } from 'mint-ui'
import { Field } from 'mint-ui';
import VueSocketio from 'vue-socket.io'

Vue.component(Field.name, Field);
Vue.component(Button.name, Button)
Vue.component(Cell.name, Cell)
Vue.use(MintUI)


import NProgress from 'nprogress'

// Vue.use(new VueSocketio({
//   debug: false,
//   connection: URLS.webSocket_API,
//   options: {
//     autoConnect: false
//   }
// }));


import App from './App'
import store from './store'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/font-awesome-4.7.0/css/font-awesome.min.css'
import '@/assets/css/main.css'
import '@/assets/css/scrollbar.css'
import '@/assets/css/reset.css'
import 'nprogress/nprogress.css'
import 'animate.css'
import URLS from '../config/urls'
import DropdownPlugin from './m/dropdown'
import NavbarPlugin from './m/navbar'
import ContextMenuPlugin from './m/context-menu'
import MButton from '@/m/button'
import MSwitch from '@/m/switch'
import MAlert from '@/m/alert'
import MCheckbox from '@/m/checkbox'
import MInput from '@/m/input'
import MLoading from '@/m/loading'
import Mkeyboard from '@/m/keyboard'
import MNumberkeyboard from '@/m/number-keyboard'
import MBox from '@/m/box'
import MBackTop from '@/m/back-top'
import MLoader from '@/m/loader'
import MContainer from '@/m/container'
import GlobalFunc from './utils/global/index'
import './assets/icon/iconfont.css' // icon
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
import echarts from 'echarts'

Vue.use(ElementUI)

Vue.use(DropdownPlugin)
Vue.use(NavbarPlugin)
Vue.use(ContextMenuPlugin)
Vue.use(MButton)
Vue.use(MSwitch)
Vue.use(MAlert)
Vue.use(MCheckbox)
Vue.use(MInput)
Vue.use(MLoading)
Vue.use(Mkeyboard)
Vue.use(MNumberkeyboard)
Vue.use(MBox)
Vue.use(MBackTop)
Vue.use(MLoader)
Vue.use(MContainer)
Vue.use(GlobalFunc)
Vue.use(mavonEditor)
Vue.prototype.$echarts = echarts;





router.afterEach(transition => {
  setTimeout(() => {
    NProgress.done()
  })
})


window.APP_INFO = process.env.APP_INFO



function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


const passwordLoginHosts = ['monitor_huidu.ushow.media', 'monitor-huidu.ushow.media']
var loginMethod = passwordLoginHosts.indexOf(window.location.hostname) > -1 ? "password" : "sso";


if (loginMethod === "sso") {
  console.log("当前的登录模式: sso")
  router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.path === '/login') {
      sessionStorage.removeItem('user')
      localStorage.removeItem('user')
    }
    let user = JSON.parse(localStorage.getItem('user'));
    var next_path = to.path;
    // if (to.path === '/mb/meeting/detail/2') {
    if (to.path.match("^/suborder/approve/wx/.*")) { //桌面端免密
      localStorage.setItem("token", to.params["token"])
      localStorage.removeItem("allow")
      next()
    } else if (to.path.match("^/mb/suborder/approve/wx/.*")) { //移动端免密
      localStorage.setItem("token", to.params["token"])
      localStorage.removeItem("allow")
      next()
    } else if(to.path.match("^/user/info/passwd/.*")) {
      localStorage.setItem("token", to.params["token"])
      localStorage.removeItem("allow")
      next()
    } else if (to.path === '/callback') {
      next()
    } else {
      if (from.path.match("^/suborder/approve/wx/.*") || from.path.match("^/mb/suborder/approve/wx/.*")) { //从免密页面跳转到其他页面不予放行
        if (!localStorage.getItem("allow")) {
          localStorage.setItem("allow", "1")
          next({path: '/login?next=' + next_path})
        } else {
          next()
        }
      } else if (!user) {
        localStorage.setItem("next",to.path)
        var host = escape(window.location.protocol + "//" + window.location.host + "/callback");
        var state = guid()
        var cilent = window.location.host.split(".")[0]
        var url = `https://keycloak.ushow.media/auth/realms/starx/protocol/openid-connect/auth?client_id=${cilent}&redirect_uri=${host}&state=${state}&response_type=code&scope=openid`
        window.location.href = url
      } else {
        next()
      }

    }
  })
}else {
  router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.path === '/login') {
      sessionStorage.removeItem('user')
      localStorage.removeItem('user')
    }
    let user = JSON.parse(localStorage.getItem('user'));
    // if (to.path == '/mb/meeting/detail/2') {
    if (to.path.match("^/suborder/approve/wx/.*")){ //桌面端免密
      localStorage.setItem("token",to.params["token"])
      localStorage.removeItem("allow")
      next()
    }  else if (to.path.match("^/mb/suborder/approve/wx/.*")){ //移动端免密
      localStorage.setItem("token",to.params["token"])
      localStorage.removeItem("allow")
      next()

    } else if(to.path.match("^/user/info/passwd/.*")) {
      localStorage.setItem("token", to.params["token"])
      localStorage.removeItem("allow")
      next()
    } else {
      var next_path = to.path;
      if (from.path.match("^/suborder/approve/wx/.*") || from.path.match("^/mb/suborder/approve/wx/.*")) { //从免密页面跳转到其他页面不予放行
        if (!localStorage.getItem("allow")){
          localStorage.setItem("allow","1")
          next({ path: '/login?next=' + next_path })
        } else {
          next()
        }

      } else if (!user && to.path !== '/login') {
        next({ path: '/login?next=' + next_path })
      } else {
        next()
      }
    }

  })

}

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

window.app = app



// WEBPACK FOOTER //
// ./src/main.js